import putin from '@/views/putin/putin'
export default {
  path: '/putin',
  name: 'putin',
  component: putin,
  meta: {
    keepAlive: true,
    title: '投放',
    code: 'page:putin',
    activeName: '/putin',
    permission: 'advertising',
    name: 'putInM'
  },
  children: [
    {
      path: 'putInM',
      name: 'putInM',
      component: resolve => require(['@/views/putin/putInM'], resolve),
      meta: {
        keepAlive: true,
        title: '投放管理',
        iconName: 'icon-toufangguanli',
        permission: 'adRelease',
        subMenuShow: false
      },
      subMenu: [
        {
          name: 'putInAccount',
          title: '投放账户'
        },
        {
          name: 'group',
          title: '广告组'
        },
        {
          name: 'plan',
          title: '计划'
        },
        {
          name: 'creative',
          title: '创意'
        }
      ],
      children: [
        {
          path: 'putInAccount',
          name: 'putInAccount',
          component: resolve => require(['@/views/putin/putInManage/putInAccount'], resolve),
          meta: {
            parents: 'putInM',
            keepAlive: true,
            title: '投放账户'
          }
        },
        {
          path: 'group',
          name: 'group',
          component: resolve => require(['@/views/putin/putInManage/group'], resolve),
          meta: {
            parents: 'putInM',
            keepAlive: true,
            title: '广告组'
          }
        },
        {
          path: 'plan',
          name: 'plan',
          component: resolve => require(['@/views/putin/putInManage/plan'], resolve),
          meta: {
            parents: 'putInM',
            keepAlive: true,
            title: '计划'
          }
        },
        {
          path: 'creative',
          name: 'creative',
          component: resolve => require(['@/views/putin/putInManage/creative'], resolve),
          meta: {
            parents: 'putInM',
            keepAlive: true,
            title: '创意'
          }
        },
        {
          path: 'copyPlan',
          name: 'copyPlan',
          component: resolve => require(['@/views/putin/putInManage/copyPlan'], resolve),
          meta: {
            parents: 'putInM',
            keepAlive: true,
            title: '克隆计划'
          }
        }
      ]
    },
    // {
    //   path: 'strategy',
    //   name: 'strategy',
    //   component: resolve => require(['@/views/putin/strategy'], resolve),
    //   meta: {
    //     keepAlive: true,
    //     title: '策略投放',
    //     iconName: 'icon-celveguanli',
    //     permission: 'strategy'
    //   },
    //   children: [
    //     {
    //       path: 'createStrategy',
    //       name: 'createStrategy',
    //       component: resolve => require(['@/views/putin/strategy/createStrategy'], resolve),
    //       meta: {
    //         keepAlive: true,
    //         sidebar: true,
    //         title: '新建策略'
    //       }
    //     },
    //     {
    //       path: 'intelligentTemplate',
    //       name: 'intelligentTemplate',
    //       component: resolve => require(['@/views/putin/strategy/intelligentTemplate'], resolve),
    //       meta: {
    //         keepAlive: true,
    //         sidebar: true,
    //         title: '智能模板'
    //       }
    //     }
    //   ]
    // },
    {
      path: 'template',
      name: 'plTemplate',
      component: resolve => require(['@/views/putin/template'], resolve),
      meta: {
        keepAlive: true,
        title: '投放模板',
        iconName: 'icon-celveguanli',
        permission: 'strategy'
      },
      children: [
        {
          path: 'createTemplate',
          name: 'createTemplate',
          component: resolve => require(['@/views/putin/template/createTemplate'], resolve),
          meta: {
            keepAlive: true,
            sidebar: false,
            title: '新建模板'
          },
          children: [
            {
              path: 'account',
              name: 'templateAccount',
              component: resolve => require(['@/views/putin/template/account'], resolve),
              meta: {
                keepAlive: true,
                sidebar: false,
                title: '模板账户信息'
              }
            },
            {
              path: 'channel',
              name: 'templateChannel',
              component: resolve => require(['@/views/putin/template/channel'], resolve),
              meta: {
                keepAlive: true,
                sidebar: false,
                title: '模板渠道信息'
              }
            },
            {
              path: 'creative',
              name: 'templateCreative',
              component: resolve => require(['@/views/putin/template/creative'], resolve),
              meta: {
                keepAlive: true,
                sidebar: false,
                title: '模板创意信息'
              }
            }
          ]
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/putin.js